import { AxiosError } from 'axios';
import { types, flow, Instance } from 'mobx-state-tree';
import axios from 'utils/axios.config';
import { withAlertStore } from 'components/Core/CustomAlert/store';
import { ErrorData, IResponse } from 'types/common';
import { ICoverageRequest, ICoverageResult } from './types';

const { model, frozen, maybeNull, optional } = types;

export const SearchCoverageStore = model('SearchCoverageStore', {
  coverageData: maybeNull(frozen<ICoverageResult>()),
  loading: optional(types.boolean, false),
})
  .extend(withAlertStore)
  .actions((self) => ({
    setCoverageData(data: ICoverageResult | null) {
      self.coverageData = data;
    },
    setLoading(value: boolean) {
      self.loading = value;
    },
  }))
  .actions((self) => ({
    errorHandling({ response }: AxiosError<IResponse<ErrorData>>) {
      const msg = response?.data.message || 'Internal server error';
      self.alertStore.showAlert(msg);
      throw new Error(msg);
    },
  }))
  .actions((self) => ({
    runCoverage: flow(function* (payload: ICoverageRequest) {
      self.setLoading(true);
      try {
        return yield axios
          .post('search/coverage', payload)
          .then(({ data: { data } }) => {
            self.setCoverageData(data);
            return data as ICoverageResult;
          })
          .catch(self.errorHandling);
      } finally {
        self.setLoading(false);
      }
    }),
    clearCoverage() {
      self.setCoverageData(null);
    },
  }));

export type ISearchCoverageStore = Instance<typeof SearchCoverageStore>;
